export function NoOptionsMessagePlugin(options) {
  const tomSelect = this
  const message = options.message

  tomSelect.settings.shouldLoad = () => true

  tomSelect.settings.render.no_results = function() {
    if (Object.keys(this.options).length === 0) {
      return `<div class="no-results option-picker-no-results">${message}</div>`
    }
    return '<div class="no-results option-picker-no-results">No results found</div>'
  }
}
